<ng-container *ngIf="currentUserId; else noUserTemplate">
  <div class="chat-page">
    <div class="notifications-section" *ngIf="false">
      <div class="notifications-banner">
        <div class="banner-header">
          <div>
            <h3>Notifications</h3>
            <p class="panel-subtitle">Latest activity</p>
          </div>
          <button nz-button nzType="link" nzSize="small" (click)="openNotificationsModal()"
            [disabled]="notificationPreviewLoading && !notificationPreview.length">
            View all
          </button>
        </div>
        <nz-spin [nzSpinning]="notificationPreviewLoading">
          <ng-container *ngIf="notificationPreview.length; else noNotificationsPreview">
            <div class="notification-cards">
              <div class="notification-card"
                *ngFor="let notification of notificationPreview; trackBy: trackNotificationById">
                <div class="notification-card-title">
                  {{ getNotificationTitle(notification) }}
                </div>
                <div class="notification-card-body">
                  {{ notification.body }}
                </div>
                <div class="notification-card-meta">
                  <span>{{ notification.createdAt | date: 'short' }}</span>
                  <span class="status" [ngClass]="{ unread: !notification.readAt }">
                    {{ notification.readAt ? 'Read' : 'Unread' }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </nz-spin>
        <ng-template #noNotificationsPreview>
          <div class="empty-state compact">
            <p>{{ notificationPreviewLoading ? 'Loading notifications...' : 'You are all caught up!' }}</p>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="chat-container">
      <section class="conversation-panel">
        <div class="panel-header">
          <div>
            <h2>Conversations</h2>
            <p class="panel-subtitle">Signed in as {{ currentUserLabel || currentUserId }}</p>
          </div>
          <button nz-button nzType="default" nzSize="small" nzShape="circle" nz-tooltip
            nzTooltipTitle="Start new conversation" aria-label="Start new conversation" (click)="openCreateModal()">
            <span nz-icon nzType="plus"></span>
          </button>
        </div>

        <div class="search-bar">
          <input nz-input placeholder="Search by title..." [formControl]="searchControl" />
        </div>

        <nz-spin class="conversation-list-spin" [nzSpinning]="conversationsLoading && !conversations.length">
          <div class="conversation-list">
            <div class="conversation-card" *ngFor="let conversation of conversations"
              (click)="selectConversation(conversation)"
              [ngClass]="{ active: conversation.id === selectedConversation?.id }">
              <div class="conversation-title-row">
                <div class="conversation-title">{{ getConversationTitle(conversation) }}</div>
                <span class="unread-dot" *ngIf="conversation.hasUnread" aria-label="Unread messages"></span>
                <button nz-button nzType="link" nzSize="small" class="conversation-hide-btn"
                  (click)="hideConversation(conversation, $event)">
                  Hide
                </button>
              </div>
              <div class="conversation-meta">
                <span class="participant-names" [title]="getParticipantSummary(conversation)">
                  {{ getParticipantSummary(conversation) }}
                </span>
                <span>{{ conversation.lastMessage?.created_at | date: 'short' }}</span>
              </div>
              <div class="conversation-preview">
                {{ conversation.lastMessage?.body || 'No messages yet.' }}
              </div>
            </div>

            <div class="empty-state" *ngIf="!conversations.length && !conversationsLoading">
              <p>No conversations yet.</p>
              <button nz-button nzType="link" nzSize="small" (click)="openCreateModal()">
                Create the first conversation
              </button>
            </div>

            <div class="hidden-conversations-drawer" *ngIf="hiddenConversations.length">
              <button nz-button nzType="default" nzSize="small" class="hidden-drawer-toggle" (click)="toggleHiddenDrawer()">
                {{ hiddenDrawerOpen ? 'Hide hidden conversations' : 'Show hidden conversations (' + hiddenConversations.length + ')' }}
              </button>

              <div class="hidden-conversations-list" *ngIf="hiddenDrawerOpen">
                <div class="hidden-conversation-row"
                  *ngFor="let hiddenConversation of hiddenConversations; trackBy: trackConversationById">
                  <div class="hidden-conversation-title">
                    {{ getConversationTitle(hiddenConversation) }}
                  </div>
                  <button nz-button nzType="link" nzSize="small"
                    (click)="unhideConversation(hiddenConversation, $event)">
                    Unhide
                  </button>
                </div>
              </div>
            </div>
          </div>
        </nz-spin>

        <button nz-button nzType="default" class="load-more" *ngIf="conversationCursor" (click)="loadConversations()"
          [disabled]="conversationsLoading">
          Load more
        </button>
      </section>

      <section class="messages-panel">
        <ng-container *ngIf="selectedConversation; else selectConversationTemplate">
          <div class="panel-header sticky panel-header--space-between">
            <div class="message-header-content">
              <h2>{{ getConversationTitle(selectedConversation) }}</h2>
              <p class="panel-subtitle participant-count-line">
                Participants: {{ selectedConversation.participantIds?.length || 0 }}
              </p>
              <p class="panel-subtitle">
                Last update:
                {{
                selectedConversation.lastMessage?.created_at
                ? (selectedConversation.lastMessage?.created_at | date: 'short')
                : 'N/A'
                }}
              </p>
            </div>
            <div class="message-header-actions">
              <button nz-button nzType="default" nzSize="small" nz-tooltip nzTooltipTitle="Rename conversation"
                (click)="openRenameModal()">
                <span nz-icon nzType="edit"></span>
                Rename
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip nzTooltipTitle="Manage participants"
                (click)="openManageParticipantsModal()" *ngIf="canManageParticipants()">
                <span nz-icon nzType="team"></span>
                Participants
              </button>
            </div>
          </div>

          <div class="message-history" #messageContainer>
            <button nz-button nzType="default" nzSize="small" class="load-older" *ngIf="messagesCursor"
              (click)="loadMessages()" [disabled]="messagesLoading">
              Load older messages
            </button>

            <nz-spin [nzSpinning]="messagesLoading && !messages.length">
              <div class="message-list">
                <div class="message-row" *ngFor="let messageItem of messages"
                  [ngClass]="{ mine: messageItem.sender_id === currentUserId }">
                  <div class="message-meta">
                    <span class="author">{{ getSenderLabel(messageItem.sender_id) | titlecase }}</span>
                    <span class="timestamp">{{ messageItem.created_at | date: 'short' }}</span>
                  </div>
                  <div class="message-body">
                    {{ messageItem.body }}
                  </div>
                </div>

                <div class="empty-state" *ngIf="!messages.length && !messagesLoading">
                  <p>No messages yet. Start the conversation below.</p>
                </div>
              </div>
            </nz-spin>
          </div>

          <form class="composer" [formGroup]="messageForm" (ngSubmit)="sendMessage()">
            <textarea nz-input formControlName="body" rows="3" placeholder="Type a message..."
              (keydown)="onMessageKeydown($event)"></textarea>
            <div class="composer-actions">
              <button nz-button nzType="primary" [disabled]="messageForm.invalid || isSending" type="submit">
                {{ isSending ? 'Sending...' : 'Send' }}
              </button>
            </div>
          </form>
        </ng-container>
      </section>
    </div>
  </div>
</ng-container>

<ng-template #selectConversationTemplate>
  <div class="empty-panel">
    <h3>Select a conversation</h3>
    <p>Choose a conversation on the left to view its history and send messages.</p>
  </div>
</ng-template>

<ng-template #noUserTemplate>
  <div class="empty-panel">
    <h3>Missing session</h3>
    <p>Please sign in to access chat tools.</p>
  </div>
</ng-template>

<nz-modal nzTitle="Start a conversation" [(nzVisible)]="createModalVisible" (nzOnCancel)="closeCreateModal()"
  (nzOnOk)="createConversation()" [nzConfirmLoading]="creatingConversation" [nzStyle]="{ top: '24px' }"
  [nzBodyStyle]="{ maxHeight: '70vh', overflowY: 'auto' }" nzOkText="Create">
  <ng-container *nzModalContent>
    <form [formGroup]="createConversationForm" class="create-conversation-form">
      <label>Title</label>
      <input nz-input formControlName="title" placeholder="Optional friendly name" />

      <ng-container *ngIf="selectedCompanyId; else noCompanyAvailable">
        <div class="user-picker">
          <label>Participants</label>
          <nz-input-group nzPrefixIcon="search">
            <input nz-input placeholder="Search users by name or email" [formControl]="userSearchControl" />
          </nz-input-group>
          <div class="hint">Select at least one teammate (you are already included).</div>

          <div class="selected-users" *ngIf="selectedParticipantIds.size">
            <nz-tag nzMode="closeable" *ngFor="let user of selectedUsers"
              (nzOnClose)="toggleParticipant(user.id, false)">
              {{ user.first_name | titlecase }} {{ user.last_name | titlecase }}
            </nz-tag>
          </div>

          <nz-spin [nzSpinning]="usersLoading">
            <div class="user-list-wrapper">
              <app-user-selection-list [users]="userSelectionItems" [isSelected]="participantSelectionChecker"
                (toggleSelection)="toggleParticipant($event.userId, $event.checked)"></app-user-selection-list>
            </div>
            <div class="empty-state" *ngIf="!userSelectionItems.length && !usersLoading">
              <p>No users match your search.</p>
            </div>
          </nz-spin>
        </div>
      </ng-container>
      <ng-template #noCompanyAvailable>
        <div class="empty-state compact">
          <p>Your account is not associated with a company. Please contact an admin.</p>
        </div>
      </ng-template>
    </form>
  </ng-container>
</nz-modal>

<nz-modal nzTitle="Rename conversation" [(nzVisible)]="renameModalVisible" (nzOnCancel)="closeRenameModal()"
  (nzOnOk)="renameConversation()" [nzConfirmLoading]="renamingConversation" nzOkText="Save">
  <ng-container *nzModalContent>
    <form [formGroup]="renameConversationForm" class="rename-conversation-form">
      <label>Title</label>
      <input nz-input formControlName="title" placeholder="Conversation name" />
      <div class="hint">Leave blank to remove the custom name.</div>
    </form>
  </ng-container>
</nz-modal>

<nz-modal nzTitle="Manage participants" [(nzVisible)]="manageModalVisible" (nzOnCancel)="closeManageParticipantsModal()"
  [nzStyle]="{ top: '24px' }" [nzBodyStyle]="{ maxHeight: '70vh', overflowY: 'auto' }" [nzFooter]="null">
  <ng-container *nzModalContent>
    <div class="manage-participants">
      <section class="manage-section">
        <h4>Remove participant</h4>
        <div class="hint">Removing the last participant will disband the conversation.</div>
        <div class="selected-users" *ngIf="getRemovableParticipantIds().length">
          <nz-tag *ngFor="let participantId of getRemovableParticipantIds()"
            [nzMode]="managingParticipants ? 'default' : 'closeable'"
            (nzOnClose)="removeParticipantFromConversation(participantId)">
            {{ getParticipantDisplayName(participantId) }}
          </nz-tag>
        </div>
        <div class="empty-state compact" *ngIf="!getRemovableParticipantIds().length">
          <p>No removable participants.</p>
        </div>
      </section>

      <section class="manage-section">
        <h4>Add participant</h4>
        <nz-input-group nzPrefixIcon="search">
          <input nz-input placeholder="Search users" [formControl]="manageUserSearchControl" />
        </nz-input-group>
        <div class="hint">Pick one user to add to the conversation.</div>

        <nz-spin [nzSpinning]="usersLoading || managingParticipants">
          <div class="user-list-wrapper">
            <app-user-selection-list [users]="manageUserSelectionItems" [isSelected]="manageSelectionChecker"
              [disabled]="managingParticipants"
              (toggleSelection)="handleManageToggle($event)"></app-user-selection-list>
          </div>
          <div class="empty-state compact" *ngIf="!manageFilteredUsers.length && !usersLoading">
            <p>No available users to add.</p>
          </div>
        </nz-spin>
      </section>
    </div>
  </ng-container>
</nz-modal>

<nz-modal nzTitle="Notifications" [(nzVisible)]="notificationsModalVisible" (nzOnCancel)="closeNotificationsModal()"
  [nzFooter]="null">
  <div class="notifications-modal">
    <nz-spin [nzSpinning]="notificationsLoading && !notificationsList.length">
      <ng-container *ngIf="notificationsList.length; else notificationsModalEmpty">
        <div class="notification-card full"
          *ngFor="let notification of notificationsList; trackBy: trackNotificationById">
          <div class="notification-card-title">
            {{ getNotificationTitle(notification) }}
          </div>
          <div class="notification-card-body">
            {{ notification.body }}
          </div>
          <div class="notification-card-meta">
            <span>{{ notification.createdAt | date: 'short' }}</span>
            <span class="status" [ngClass]="{ unread: !notification.readAt }">
              {{ notification.readAt ? 'Read' : 'Unread' }}
            </span>
          </div>
        </div>
      </ng-container>
    </nz-spin>
    <ng-template #notificationsModalEmpty>
      <div class="empty-state compact">
        <p>{{ notificationsLoading ? 'Loading notifications...' : 'No notifications yet.' }}</p>
      </div>
    </ng-template>
    <button nz-button nzType="default" class="load-more" *ngIf="notificationsCursor" (click)="loadUserNotifications()"
      [disabled]="notificationsLoading">
      Load more
    </button>
  </div>
</nz-modal>
